import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Inbox } from 'lucide-react';

const PLACEHOLDER_COLUMNS = ['Date', 'Name', 'Email', 'Service', 'Source', 'Status'];

export default function LeadInbox() {
  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3">
        <h1 className="text-3xl font-bold">Lead Inbox</h1>
        <Badge variant="secondary">Coming soon</Badge>
      </div>
      <p className="text-muted-foreground">
        Review and manage leads captured from your website forms and integrations.
      </p>

      {/* Empty State */}
      <Card>
        <CardContent className="flex flex-col items-center justify-center py-16 text-center">
          <Inbox className="w-12 h-12 text-muted-foreground mb-4" />
          <h3 className="text-lg font-semibold mb-2">No leads yet</h3>
          <p className="text-muted-foreground max-w-md">
            Lead form submissions will appear here once tracking is set up.
            Leads are captured from contact forms, quote requests, and inquiry forms on your website.
          </p>
        </CardContent>
      </Card>

      {/* Placeholder Table */}
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Recent Leads</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                {PLACEHOLDER_COLUMNS.map((col) => (
                  <TableHead key={col}>{col}</TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell colSpan={PLACEHOLDER_COLUMNS.length} className="text-center text-muted-foreground py-8">
                  No lead data available. Set up form tracking or connect an integration to start capturing leads.
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
